/* 
	!	REF
	*	
	*	Make the following changes in scripts
	*	in package.json
	*	
	!	"start": "REACT_APP_STAGE=dev react-scripts start",
	*	"build": "react-scripts build",
	*	"test": "react-scripts test --env=jsdom",
	*	
	!	"predeploy": "REACT_APP_STAGE=dev npm run build",
  	*	"deploy": "aws s3 sync build/ s3://YOUR_DEV_S3_DEPLOY_BUCKET_NAME",
	*	"postdeploy": "aws cloudfront create-invalidation --distribution-id YOUR_DEV_CF_DISTRIBUTION_ID --paths '/*' && aws cloudfront create-invalidation --distribution-id YOUR_DEV_WWW_CF_DISTRIBUTION_ID --paths '/*'",
	*	
	!	"predeploy:prod": "REACT_APP_STAGE=production npm run build",
	*	"deploy:prod": "aws s3 sync build/ s3://YOUR_PROD_S3_DEPLOY_BUCKET_NAME",
	*	"postdeploy:prod": "aws cloudfront create-invalidation --distribution-id YOUR_PROD_CF_DISTRIBUTION_ID --paths '/*' && aws cloudfront create-invalidation --distribution-id YOUR_PROD_WWW_CF_DISTRIBUTION_ID --paths '/*'",
	*	
	*	"eject": "react-scripts eject"
    *   
    *             ___________________________________________________________________________________
    *   ________|                                      												|_______
    *   \       |     https://serverless-stack.com/chapters/environments-in-create-react-app.html   |      /
    *    \      |                                      												|     /
    *    /      |___________________________________________________________________________________|     \
    *   /__________)                                										     (_________\
    *   
    *	
*/
// vpc enabled api urls
const dev = {
  env: "dev",
  BASE: "https://gateway.apim-dev.lilly.com/customer-search/dev/",
  API_RESPONSE_LIMIT: 5000,
  MSAL_REDIRECT_URI: "https://ecs-dev.lilly.com",
  MSAL_CLIENT_ID: "c815fc99-1f0c-4fb6-96d3-67d262c62cc9",
  MSAL_TENANT_ID: "18a59a81-eea8-4c30-948a-d8824cdc2580",
  ECS2_URL: "https://customer-search-dev.lilly.com"
};

const dev_2 = {
  env: "dev",
  BASE: "https://gateway.apim-dev.lilly.com/customer-search/dev2/",
  API_RESPONSE_LIMIT: 5000,
  MSAL_REDIRECT_URI: "https://d2uvuz1jn4usmq.cloudfront.net/",
  MSAL_CLIENT_ID: "c815fc99-1f0c-4fb6-96d3-67d262c62cc9",
  MSAL_TENANT_ID: "18a59a81-eea8-4c30-948a-d8824cdc2580",
  ECS2_URL: "https://customer-search-dev.lilly.com"
};

const qa = {
  env: "qa",
  BASE: "https://gateway.apim-qa.lilly.com/customer-search/qa/",
  API_RESPONSE_LIMIT: 5000,
  MSAL_REDIRECT_URI: "https://ecs-qa.lilly.com",
  MSAL_CLIENT_ID: "34b0e8b7-9b23-4a3c-a841-fd753839f88d",
  MSAL_TENANT_ID: "18a59a81-eea8-4c30-948a-d8824cdc2580",
  ECS2_URL: "https://customer-search-qa.lilly.com"
};

const qa_2 = {
  env: "qa",
  BASE: "https://gateway.apim-qa.lilly.com/customer-search/qa/",
  API_RESPONSE_LIMIT: 5000,
  MSAL_REDIRECT_URI: "https://d1f8qcxtb4ax3p.cloudfront.net",
  MSAL_CLIENT_ID: "34b0e8b7-9b23-4a3c-a841-fd753839f88d",
  MSAL_TENANT_ID: "18a59a81-eea8-4c30-948a-d8824cdc2580",
  ECS2_URL: "https://customer-search-qa.lilly.com"
};

const prod = {
  env: "prod",
  BASE: "https://gateway.apim.lilly.com/customer-search/prod/",
  API_RESPONSE_LIMIT: 5000,
  MSAL_REDIRECT_URI: "https://ecs.lilly.com",
  MSAL_CLIENT_ID: "a2ac6b3c-d51e-4200-be47-c6f851a60e89",
  MSAL_TENANT_ID: "18a59a81-eea8-4c30-948a-d8824cdc2580",
  ECS2_URL: "https://customer-search.lilly.com"
};
  
  
  const config =
    process.env.REACT_APP_STAGE === "prod"
      ? prod
      : process.env.REACT_APP_STAGE === "qa"
      ? qa
      : process.env.REACT_APP_STAGE === "qa_2"
      ? qa_2
      : process.env.REACT_APP_STAGE === "dev_2"
      ? dev_2
      : dev;
  
  const CONFIG = {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 5000000,
    ...config,
  };
  export default   CONFIG; 
  